import _ from 'lodash';
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { BigButtons } from '~/components';
import { Overlay } from './Overlay';

const buttons = [
  {
    label     : 'Sign In / Sign Out without Pass',
    icon      : 'fas:sign-in-alt',
    shortcut  : 'S',
    overlay   : 'PasslessSignInOverlay',
    setting   : 'passlessSignIn.enabled',
  },
  {
    label     : 'Log In with Username/Password',
    icon      : 'fas:user-plus',
    shortcut  : 'L',
    overlay   : 'LoginOverlay',
    setting   : 'stationLogin.enabled',
  },
];

export function MoreOptionsOverlay( props ) {
  return (
    <Overlay {...props}>
      <Container fluid>
        <Row>
          <Col><BigButtons buttons={buttons} /></Col>
          <Col>
          </Col>
        </Row>
      </Container>
    </Overlay>
  );
}
MoreOptionsOverlay.propTypes = {};
